export default "https://assets-v2.scaler.com/packs/images/chatbot-close.97c433.svg";